'use client';

import React from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@/components/ui/carousel';
import { Media } from '@/components/Media';
import type { Staff } from '@/payload-types';

export const StaffSlider: React.FC<{
  title: string;
  staff: Staff[];
}> = ({ title, staff }) => {
  return (
    <section className="v-margin" data-name="StaffSlider">
      <div className="container">
        <h2 className="h2 mb-[43px] md:mb-6">{title}</h2>

        <Carousel opts={{ align: 'start' }}>
          <CarouselContent className="-ml-6">
            {staff.map((doc) => {
              return (
                <CarouselItem
                  className="basis-1/4 pl-6 md:basis-full"
                  key={doc.id}
                >
                  <div className="corners-md relative mb-4 aspect-[326/336] overflow-hidden bg-[#F8F8F8] mix-blend-darken md:aspect-square">
                    <Media resource={doc.photo} size="medium" fill />
                  </div>
                  <div className="corners-sm bg-[#F3F3F3] p-[14px] pb-[18px] text-center">
                    <p className="h7">{doc.name}</p>
                    <p className="text-gray-200">{doc.specialization}</p>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>

          <CarouselControls />
        </Carousel>
      </div>
    </section>
  );
};
